export const formatTwoDecimals = (value: any) => {
  if (value === null || value === undefined || value === "" || value === "-") return "-";

  const num = Number(value);
  if (isNaN(num)) return value;

  const trimmed = num.toFixed(2).replace(/\.00$/, "");
  const [intPart, decPart] = trimmed.split(".");
  const withSep = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decPart !== undefined ? `${withSep}.${decPart}` : withSep;
};

/** Exchange rate fields: always 3 decimal places */
export const formatThreeDecimals = (value: any): string => {
  if (value === null || value === undefined || value === "" || value === "-") return "-";
  const num = Number(value);
  if (isNaN(num)) return String(value);
  const [intPart, decPart] = num.toFixed(3).split(".");
  return `${intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${decPart}`;
};

/** Safety stock (weeks) & variation (weeks): 1 decimal, standard rounding */
export const formatOneDecimal = (value: any): string => {
  if (value === null || value === undefined || value === "" || value === "-") return "-";
  const num = Number(value);
  if (isNaN(num)) return String(value);
  const [intPart, decPart] = num.toFixed(1).split(".");
  return `${intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${decPart}`;
};

/** Value fields (IO SS value, S4 SS value, etc.): 0 decimals + thousand separators */
export const formatValueNoDecimals = (value: any, currencySymbol = ""): string => {
  if (value === null || value === undefined || value === "" || value === "-") return "-";
  // Strip any existing currency prefix before parsing
  const stripped = String(value).replace(/^[^0-9\-.]+/, "");
  const num = Number(stripped);
  if (isNaN(num)) return String(value);
  const normalized = Math.round(num);
  const formatted = normalized === 0 ? "0" : normalized.toLocaleString("en-US");
  return currencySymbol ? currencySymbol + formatted : formatted;
};

/** Variation % fields: 0 decimals + "%" suffix */
export const formatPercentNoDecimals = (value: any): string => {
  if (value === null || value === undefined || value === "" || value === "-") return "-";
  // If already a string with %, strip it, re-round, re-add
  const stripped = String(value).replace(/%$/, "").trim();
  const num = Number(stripped);
  const normalized = Math.round(num);
  const formatted = normalized === 0 ? "0" : normalized.toLocaleString("en-US");
  if (isNaN(num)) return String(value);
  return formatted + "%";
};